module.exports = __webpack_public_path__ + "img/MARGUERITE HARPER, MEMBER OF STANDING SENATE COMMITTEE, CREDENTIALS AND ELECTIONS, THE 1969 BUGLE.b53dedbb.jpg";